"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletOld = void 0;
const react_1 = __importDefault(require("react"));
const wallet_old_1 = __importDefault(require("../icons-path/wallet-old"));
const icons_svg_1 = require("../icons-svg");
require("../icons.types");
const WalletOld = (_a) => {
    var { viewBox } = _a, props = __rest(_a, ["viewBox"]);
    return react_1.default.createElement(icons_svg_1.IconsSvg, Object.assign({}, props, { path: wallet_old_1.default, viewBox: viewBox || '0 0 22 24' }));
};
exports.WalletOld = WalletOld;
